import { gql } from "@apollo/client";

export const HELPBUTTON_POPOVER_OPEN_QUERY = gql`
  query helpButton {
    helpButton @client {
      popoverOpen
    }
  }
`;

export const SUPPORT_CONTACT = gql`
  query getSupportContact {
    getSupportContact {
      boSupportName
      boSupportPhone
      boSupportEmail
      boSupportPicture
    }
  }
`;
